export default {
  methods: {
    blockUser: async function (username) {
      await this.$axios.post("/block-user", {
        blocked_username: username,
      });
    },

    unblockUser: async function (username) {
      await this.$axios.delete("/blocked-user", {
        params: {
          user: username,
        },
      });
    },
  },
};
